export default "__VITE_ASSET__DQr1SBLJ__"